/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, OnInit } from '@angular/core';
declare function sendData(data: string): string;

@Component({
    selector: 'app-draw-lottery-net-game-result-coupon',
    templateUrl: './draw-lottery-net-game-result-coupon.component.html',
    styleUrls: ['./draw-lottery-net-game-result-coupon.component.css'],
})
export class DrawLotteryNetGameResultCouponComponent implements OnInit {
    constructor() { }

    ngOnInit(): void {
        const lotteryPrize = sessionStorage.getItem('lottery_prize');
        if (lotteryPrize) {
            sendData(lotteryPrize);
        }
    }
}
